import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-ticket-status-review',
  templateUrl: './ticket-status-review.component.html',
  styleUrls: ['./ticket-status-review.component.scss']
})
export class TicketStatusReviewComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router,public toastr:ToastrService) { }

  ngOnInit(): void {
    this.appservice.GetTicket_For_Status();
  }
  editEmployee(data){
    this.appservice.TicketEdituser=data;
  this.router.navigate(['/home/Ticket-EmpReview'])
  // this.appservice.getTable("api/Transaction/ResendPendingTicket?id="+data).subscribe({
  //   next:(res:any)=>{
  //     if(res){
  //       this.toastr.success("The Ticket Return For Approval","Notice");
  //     }
  //   },
  //   error:(err:any)=>{
  //     this.toastr.error(err,"Error");
  //   }
  // })
  // console.log("the edit id",data);
  
}
}
